import { render, staticRenderFns } from "./Beatmaps.vue?vue&type=template&id=7bc2fb67&"
import script from "./Beatmaps.vue?vue&type=script&lang=js&"
export * from "./Beatmaps.vue?vue&type=script&lang=js&"
import style0 from "./Beatmaps.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports